
import {
    WithReportFormatContentPayload
} from '../../../../../reporting/report/impl/service/payload/withReportFormatContent.payload';
import {
    ReportFormatContentPayload
} from '../../../../../communication/common/api/service/reportFormatContent.payload';

export class DefaultReportFormatContentPayload implements WithReportFormatContentPayload {
    report: ReportFormatContentPayload;
}
